import { atom, useAtomValue } from "jotai";

import { PackageOrderFooter } from "../../PackageOrderFooter";
import { CurrentPackagesModalAtom, onBackAtom } from "../atoms";

export const CurrentPackageOrderFooter = () => {
  const orderId = useAtomValue(orderIdAtom);
  const packageId = useAtomValue(packageIdAtom);

  const onBack = useAtomValue(onBackAtom);

  return (
    <PackageOrderFooter
      packageId={packageId!}
      orderId={orderId!}
      onBack={onBack}
    />
  );
};

const orderIdAtom = atom((get) => {
  const state = get(CurrentPackagesModalAtom);
  if (state.page !== "order") return null;

  return state.orderId;
});

const packageIdAtom = atom((get) => {
  const state = get(CurrentPackagesModalAtom);
  if (state.page !== "order") return null;

  return state.packageId;
});
